import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    toggleSwitch: {
        toggle: {
            base: 'relative rounded-full after:absolute after:rounded-full after:bg-white after:transition-all group-focus:ring-4 group-focus:ring-primary-500/25',
            checked: {
                color: {
                    primary: 'bg-primary-700 border-primary-700',
                },
            },
        },
    },
}).toggleSwitch;
